<rask-page pageTitle="Transportföretag" noPadding>
    <div #header>
        @if (transportforetag) {
        <div>
            <rask-toggle-panel label="{{transportforetag.namn}}" [defaultExpanded]="true"
                (onToggle)="onToggleHeader($event)">
                <ng-container header>
                    {{ showSelected() }}
                </ng-container>
                <ng-container>
                    <div [formGroup]="formTransportforetag" class="inline col-lg-10">
                        <div class="colorpicker-container">
                            <fieldset class="form-group inline mb-3">
                                <label>FÄRG</label>
                                <div class="picker-input-group">
                                    <div (click)="openColorPicker()" class="colorpicker"
                                        [ngStyle]="{'background-color' : transportforetag.color }">
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <rask-input [readonly]="true" formControlName="orgNummer" class="width-large"
                            label="ORGNR" [rule]="">
                        </rask-input>
                        <rask-input [readonly]="true" formControlName="huvudkod" class="width-large"
                            label="Transportföretag"
                            [rule]="">
                        </rask-input>
                        <rask-input [readonly]="true" formControlName="limeId" class="width-small"
                            label="LIME-ID" [rule]="">
                        </rask-input>
                        <rask-input [readonly]="true" [value]="getAktivText(transportforetag.aktiv)" class="width-small"
                            label="AKTIV" [rule]="">
                        </rask-input>
                        <rask-input [readonly]="true" class="width-large"
                            label="TILLDELAD VOLYM"
                            [rule]="">
                        </rask-input>
                        <rask-input formControlName="transportkapacitet" [disabled]="!transportforetag.aktiv"
                            label="TRANSPORTKAPACITET (TONKM)"
                            [rule]="">
                        </rask-input>
                        <rask-checkbox text="Transportunderlag extern" formControlName="transportunderlagTillExtern">
                        </rask-checkbox>
                    </div>
                    <div class="inline col-lg-2">
                        <rask-radiobutton-group
                            class="w-100"
                            selectedOption="1"
                            [(ngModel)]="transportsatt"
                            aid="omrade-radio"
                            [buttons]="[{ key: 1, value: 'Rundvirke',  }, { key: 2, value: 'Bränsle' }]"
                            [onBeforeChange]="onBeforeChangeTransportsatt"
                            (change)="transportsattChanged()">
                        </rask-radiobutton-group>
                    </div>
                </ng-container>
            </rask-toggle-panel>
        </div>
        }
    </div>
    <div class="row" class="mapcontainer">
        <div class="col-12" #mapcontainer>
            <div style="width: 100%; position: relative">
                <rask-map [settings]="mapsettings" [refresh]="refresh" [filter]="filter">
                    <rask-map-draw [enabled]="true"></rask-map-draw>
                    <rask-map-layers></rask-map-layers>
                </rask-map>
            </div>
        </div>
    </div>
    <div class="infowindow" #infowindow>
        @if (selectedTransportforetag) {
        <span>
            <a href="/core/transportforetag/{{selectedTransportforetag.id}}">
                {{selectedTransportforetag.namn}}
            </a>&nbsp;{{ selectedTransportforetag.huvudkod }}</span>
        }
    </div>
    <ng-container footerContent>
        <div #footer>
            <rask-save-button [disabled]="!canSave()" (click)="onSave()"></rask-save-button>
        </div>
    </ng-container>
</rask-page>